import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../../../firebase";
import { doc, getDoc } from "firebase/firestore";
import AdminDashboard from "../../../components/AdminDashboard/AdminDashboard";

const AdminPage = () => {
  const [isAdmin, setIsAdmin] = useState(null); // 관리자 여부 확인
  const navigate = useNavigate();

  useEffect(() => {
    const checkAdmin = async () => {
      const user = auth.currentUser;
      if (!user) {
        navigate("/"); // 로그인 안 된 유저 홈으로 이동
        return;
      }

      const userRef = doc(db, "users", user.uid);
      const userSnap = await getDoc(userRef);

      if (userSnap.exists() && userSnap.data().role === "admin") {
        setIsAdmin(true);
      } else {
        navigate("/"); // 관리자가 아니면 홈으로 이동
      }
    };

    checkAdmin();
  }, [navigate]);

  if (isAdmin === null) return <p>관리자 확인 중...</p>;

  return <AdminDashboard />; // 관리자는 대시보드 보여주기
};

export default AdminPage;
